<template>
  <div>
    <HeaderUser ></HeaderUser>
    <el-menu :default-active="this.$route.fullPath" mode="horizontal" router style="background-color: transparent !important;">
      <el-menu-item index="/back/classify" class="menuBut">分类管理</el-menu-item>
      <el-menu-item index="/back/content" class="menuBut">内容管理</el-menu-item>
      <el-menu-item index="/back/caseType" class="menuBut">工程案例类别</el-menu-item>
      <el-menu-item index="/back/qiYeYanGe" class="menuBut">企业沿革</el-menu-item>
    </el-menu>
    <div class="listBg7">
    <div class="table" style="margin-top: 10px;">
      <el-button-group>
        <a class="btnSmallStyle" @click="editRow()"  style="width: 70px;height: 32px;line-height: 32px;margin-right: 10px">添加</a>
      </el-button-group>
      <el-table v-loading="loading" :element-loading-text="'数据加载中'" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" ref="multipleTable" :data="tableData" style="width: 100%;box-sizing: border-box;border: 2px solid #4a98db;background-color: transparent !important;" :max-height="786" stripe >
        <el-table-column prop="id" label="编号" header-align="center" align="center" ></el-table-column>
        <el-table-column prop="name" label="名称" header-align="center" align="center" ></el-table-column>
        <el-table-column prop="imgUrls" label="图片" header-align="center" align="center" width="250px">
           <template slot-scope="scope" >
　　　　     <img v-if="scope.row.img" :src="scope.row.img" width="60" height="60" class="head_pic" style="margin-right: 10px;"/>
       　　</template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" header-align="center" align="center" ></el-table-column>
        <el-table-column fixed="right" label="操作" header-align="center" align="center" >
          <template slot-scope="scope">
            <el-button size="mini" @click="editRow(scope.row)" >{{'修改'}}</el-button>
            <el-button size="mini"  type="danger" @click="deleteRow(scope.row)" >{{'删除'}}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    </div>

<el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" :close-on-click-modal="false" :destroy-on-close="true"  width="920px" >
      <el-form :model="form">
        <el-form-item label="名称" :label-width="formLabelWidth">
          <el-input v-model="form.name"  autocomplete="off" ></el-input>
        </el-form-item>

        <el-form-item label="图片" :label-width="formLabelWidth">
          <!-- <el-input v-model="form.imgUrls"  autocomplete="off" ></el-input> -->
          <el-upload
  :action="url+'UploadController/uploadImg.action'"
  list-type="picture-card"
  accept=".png,.jpg,.jpeg,.gif"
  :file-list="imgs"
  :before-upload="beforeUpload"
  :on-success="ImgSuccess"
  :on-remove="HandleRemove">
  <i class="el-icon-plus"></i>
</el-upload>
        </el-form-item>

        <el-form-item label="排序" :label-width="formLabelWidth">
          <el-input v-model="form.sort"  autocomplete="off" ></el-input>
          <div style="color:red;line-height: 50px;">值越小越靠前</div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <a  class="btnSmallStyle" @click="dialogFormVisible = false" style="width: 70px;height: 32px;line-height: 32px;color: white;">{{'取 消'}}</a>
        <a  class="btnSmallStyle" @click="saveCaseType()"  style="width: 70px;height: 32px;line-height: 32px;color: white;margin-left: 10px">{{'确 定'}}</a>
      </div>
    </el-dialog>

  </div>
</template>
<style scoped>
  .listBg7{
    width: 1638px;
    height: 876px;
    background: url('../../../assets/images/replaceImg/listBg.png') center 100% no-repeat;
    position: absolute;
    margin-top: -16px;
  }
</style>

<style lang="sass" scoped>
.menuBut
  width: 172px
  margin-right: 10px
  margin-left: 5px
  font-size: 18px
  padding-top: 5px
  text-align: center
  background: url('../../../assets/images/replaceImg/tab_lb.png') center 100% no-repeat
  &:hover
    background: url("../../../assets/images/replaceImg/tab_lb_pre.png") center 100% no-repeat
  &.is-active
    border-bottom: none !important
    background: url("../../../assets/images/replaceImg/tab_lb_pre.png") center 100% no-repeat

.el-menu
  background-color: #1d2336 !important
  &.el-menu--horizontal
    border-bottom: none


.table
  display: block
  overflow: hidden
  padding: 20px
  background-color: transparent

.el-button-group
  padding-bottom: 10px
  button
    width: 100px

.cell button
  width: 58px

.dialog-footer button
  width: 80px

.el-pagination
  float: right
  padding: 20px

.el-select
  width: 100%
</style>

<script>
import store from "@/store";
import utils from '@/lib/utils'
import config from "@/config";
import HeaderUser from "@/components/HeaderUser.vue";

export default {
  data() {
    return {
      height: 0,
      sysRoleValue: 1,
      blockQuery: 1,
      sysRole: [{
        value: 0,
        label: "后台管理员"
      },{
        value: 1,
        label: "普通用户"
      }],
      tableData: [],
      groupListState: false,
      optionsGroup: [],
      loading: false,
      dialogTitle: "",
      dialogTableVisible: false,
      dialogFormVisible: false,
      form: {
          id: null,
          name: '',
          sort: null
      },
      multipleSelection: [],
      formLabelWidth: '90px',
      formLabelWidth2: '130px',
      thisPage: 1,
      languageMap:{},
      imgs: [],
      url:null,
    };
  },
  mounted() {
    this.url=config.url;

    console.log("user");
    this.height = window.innerHeight;

    // '获取用户列表信息'
    this.queryAllCaseType()

    window.onresize = () => {
      this.height = window.innerHeight;
    };
  },
  computed: {
   
  },
  methods: {
    queryAllCaseType() {
      let url =  config.url + "BackController/queryAllCaseType.action";
      let param = {
      }
      this.$http.post(url, param).then(res => {
        let data = res.data;
        if(data.resultCode == 200){
          let this_=this;
          this.tableData = data.data;
        }
        else {
          this.$message.error(data.message);
        }
      })
      .catch(err => {
        console.log(err);
        this.$loading().close();
        // this.$message.error("''''请求接口失败''''");
      });
    },
    handleCurrentChange(val) {
      // console.log(`'当前页': ${val}`);
      this.thisPage = val;
      this.queryAllCaseType()
    },
    deleteRow(rowObj) {
      this.$confirm('此操作将永久删除该记录,是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
         let param={
          id: rowObj.id
        }
        let url =  config.url + "BackController/deleteCaseType.action";
      this.$http.post(url, param).then(res => {
        let data = res.data;
        if(data.resultCode == 200){
          this.$message.success(data.message);
          this.queryAllCaseType();
        }
        else {
          this.$message.error(data.message);
        }
      })
      .catch(err => {
        console.log(err);
      });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
    },
	getCookie(name) {  //'获取cookie'
  var arr = null;
  var reg = new RegExp("(^| )"+name+"=([^;]*)(;|$)");
  var arr=document.cookie.match(reg);
  if(arr) {
     return unescape(arr[2]);
  } else {
     return null;
  }
 },
 editRow(rowObj){
     if(rowObj){
         this.dialogTitle='修改'
       this.form= {
         id: rowObj.id,
         name: rowObj.name,
         sort: rowObj.sort
       }
       let imgList = rowObj.img ? rowObj.img.split(',') : [];
       let imgArr = [];
       if(imgList){
         for(let i=0; i < imgList.length; i++){
           imgArr.push({name: i+'.jpg', url: config.url+imgList[i]})
         }
       }
       this.imgs = imgArr;
       console.log('imgs=' + this.imgs)
     }else{
         this.dialogTitle='添加'
      this.form= {
          id: null,
          name: '',
          sort: null
      }
      this.imgs = [];
     }
    this.dialogFormVisible = true;
 },
 saveCaseType(){
     if(!this.form.name){
       this.$message.error("请填写名称");
       return;
     }
     if(!this.form.sort){
       this.$message.error("请填写排序");
       return;
     }

     let param = JSON.parse(JSON.stringify(this.form));
     console.log('this.imgs='+this.imgs)
      let imgUrls='';
      for(let i=0;i<this.imgs.length;i++){
        let img = this.imgs[i].url;
        imgUrls += ',' + (img.replace(config.url,''));
      }
      console.log('imgUrls='+imgUrls)
      if(!imgUrls){
        this.$message.error("至少选择一张图片");
        return false;
      }
      if(imgUrls){
        imgUrls = imgUrls.substring(1);
      }
      param.img = imgUrls;

      let url =  config.url + "BackController/saveCaseType.action";
      this.$http.post(url, param).then(res => {
        let data = res.data;
        if(data.resultCode == 200){
          this.$message.success(data.message);
          this.dialogFormVisible = false;
          this.queryAllCaseType();
        }
        else {
          this.$message.error(data.message);
        }
      })
      .catch(err => {
        console.log(err);
      });
 },
 query(){
     this.queryAllCaseType();
 },
   	beforeUpload:function(file){
       if(this.imgs.length >= 1){
			   this.$message.error('最多只能上传1张图片');
  			 return false;
       }
			if(file.type=='image/png' || file.type=='image/jpg' || file.type=='image/jpeg' || file.type=='image/gif'){
				return true;
			}
			this.$message.error('文件格式错误');
			return false;
    },
		ImgSuccess:function(response, file, fileList){
      console.log("response.resultCode="+response.resultCode)
			if(response.resultCode==200){
				this.imgs.push({name: response.data, url: config.url+'uploads/imgs/'+response.data})
			}
		},
HandleRemove(file, fileList) {
        // console.log(file, fileList);
        for(let i=0;i<this.imgs.length;i++){
          console.log(this.imgs[i].name +'=='+ file.name)
          if(this.imgs[i].name == file.name){
            this.imgs.splice(i,1);
            break;
          }          
        }
        console.log(JSON.stringify(this.imgs) +"--"+ file.name)
      }
 
  },
  components: {
    HeaderUser
  }
};
</script>
